import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import React, {Component, Fragment} from 'react';

// IMPORT PACKAGE REFERENCES
import { addPharmacy } from '../State/Actions/PharmacyActions';

// COMPONENT
class AddPharmacy extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            campaignName : '',
            mdmId : '',
        }

        this.handleChange = this.handleChange.bind(this);
    }

    addPharmacy() {
        // If a pharmacy ID is present then the new device should be attached to the pharmacy.
        this.props.addPharmacy(this.state.mdmId, this.state.campaignName);
        this.setState({deviceId: ''});
    }
    
    
    handleChange(event) {
        if (event.target.id === 'campaignName') {
            this.setState({campaignName: event.target.value});
        } else if (event.target.id === 'mdmId') {
            this.setState({mdmId: event.target.value});
        }
    }

    closed() {
        this.setState({campaignName: '', mdmId: ''});
    }

    render() {
        return (
            <div className="modal fade" id="addDeviceModal" role="dialog" aria-labelledby="addDeviceModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                    <Fragment>
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Add Pharmacy</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                        <div className="form-group">
                            <label>Campaign Name</label>
                            <input value={this.state.campaignName} onChange={this.handleChange} type="email" className="form-control" id="campaignName" aria-describedby="emailHelp" placeholder="Enter campaign name"/>
                            <small id="emailHelp" className="form-text text-muted">Enter a campaign name to identify your pharmacy.</small>
                        </div>
                        <div className="form-group">
                            <label>MDM ID</label>
                            <input value={this.state.mdmId} onChange={this.handleChange} type="email" className="form-control" id="mdmId" aria-describedby="emailHelp" placeholder="Enter pharmacy MDM ID"/>
                            <small id="emailHelp" className="form-text text-muted">Enter a unique MDM ID for your pharmacy.</small>
                        </div>
                        </div>
                        <div className="modal-footer">
                            <button onClick={() => this.closed()} type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                            <button onClick={() => this.addPharmacy()} data-dismiss="modal" type="button" className="btn btn-primary">Add Pharmacy</button>
                        </div> 
                    </Fragment>
                    </div>
                </div> 
            </div>
        )
    }
}


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
  const { } = state.devicesReducer;
  return { };
};

const mapDispatchToProps = dispatch => (
  bindActionCreators({ addPharmacy }, dispatch)
);

const hoc = connect(mapStateToProps, mapDispatchToProps)(AddPharmacy);


// EXPORT COMPONENT

export { hoc as AddPharmacy };